import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AlertService } from './alert.service';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard  {
  constructor(public authService: AuthService, public router: Router,
    public alertService: AlertService,) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {

    // TODO Rechte um die Terminals zu sehen?
    //if (this.authService.restrictions && !this.authService.restrictions.planning.canSeeAny) {
    //  return false;
    //}

    let url: string = state.url;
    return this.checkLogin(url);
  }

  checkLogin(url: string): boolean {

    if (this.authService.isLoggedIn) {
      //console.log("logged in = true");
      if (this.authService.assignNewPassword && !(url.indexOf("changePassword") > -1)) {
        this.authService.loginRedirectUrl = url;
        this.router.navigate(['/changePassword']);
        return false;
      }
      return true;
    } else {
      this.authService.loginRedirectUrl = url;
      this.router.navigate(['/login']);

      //console.log("logged in = false");
      return false;
    }
  }

}
